export default {
  placeholders: {
    delivery_zip_code: 'Postleitzahl',
    delivery_city: 'Stadt',
    delivery_street_number: 'Hausnummer',
    delivery_street_name: 'Straßenname',
    type_your_address: 'Gib deine Adresse ein',
  },
  errors: {
    address_suggestions_unavailable:
      'Adressvorschläge konnten nicht geladen werden. Du kannst deine Adresse trotzdem unten eingeben.',
  },
  buttons: {
    retry: 'Erneut versuchen',
  },
};
